import React from 'react'
import Hero from '../hero/hero'
import PreOrder from '../pre-order/pre-order'
import AboutAuthor from '../about-author/about-author'
import Contact from '../contact/contact'
import HomeMediaSection from '../sections/home-media-section'
import InstagramSection from '../sections/instagram-section/instagram-section'
import SubscribeSection from '../sections/subscribe-section/subscribe-section'

export default function Home() {
  return (
    <>
      <Hero />
      <PreOrder />
      <HomeMediaSection />
      <SubscribeSection />
      <InstagramSection />
      <AboutAuthor />
      <Contact />
    </>
  )
}
